import {Pipe, PipeTransform} from '@angular/core';
import {Observable} from 'rxjs';
import {DynamicZyxDaemonService} from '../../dynamic-xyz/dynamic-zyx-daemon.service';
import {Deliverable} from '../dex-streaming/types/deliverable';
import {DeliverableBalance} from './deliverable-balance';
import {Erc20BalancesSharedService} from './erc20-balances-shared.service';

@Pipe({
    name: 'delBalanceAsync',
    pure: true
})
export class DelBalanceAsyncPipe implements PipeTransform {

    constructor(
        private erc20BalancesSharedService: Erc20BalancesSharedService,
        private dynamicZyxDaemonService: DynamicZyxDaemonService
    ) {}

    public transform(d: Deliverable, accountAddress?: string): Observable<DeliverableBalance | undefined> {
        accountAddress = accountAddress
            || this.dynamicZyxDaemonService.dynRemote.primaryWallet$.value?.address;

        return this.erc20BalancesSharedService.getDelBalanceStream(accountAddress, d);
    }
}
